import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import UserList from '../views/cadastros/usuarios/List.vue';
import UserForm from '../views/cadastros/usuarios/Form.vue';
import ClienteList from '../views/cadastros/clientes/List.vue';
import ClienteForm from '../views/cadastros/clientes/Form.vue';
import CategoriaList from '../views/cadastros/categoria/List.vue';
//import TestAutoComplete from '../views/cadastros/usuarios/TestAutoComplete.vue';

let cadastrosRoutes = {
        path: "/cadastros",
        component: DashboardLayout,
        name: "Cadastros",
        redirect: "/cadastros/usuarios",
        children: [
                {
                        path: "usuarios",
                        name: "CAD-Usuários",
                        icon: "image",
                        components: { default: UserList }
                },
                {
                        path: "usuarios-int",
                        name: "CAD-Usuários-INT",
                        icon: "image",
                        components: { default: UserForm }
                },
                {
                        path: "clientes",
                        name: "CAD-Clientes",
                        icon: "image",
                        components: { default: ClienteList }
                },
                {
                        path: "clientes-int",
                        name: "CAD-Cliente-INT",
                        icon: "image",
                        components: { default: ClienteForm }
                },
                {
                        path: "categorias",
                        name: "CAD-Categorias",
                        icon: "image",
                        components: { default: CategoriaList }
                },



                /* ,{
                   path: "usuarios-auto",
                   name: "Usuarios-auto",
                   icon: "image",
                   components: { default: TestAutoComplete }
                 } */



        ]
};

export default cadastrosRoutes;